import styled from 'styled-components';

export default styled.div`
  position: relative;
  cursor: pointer;
  width: 100%;
  height: 4.5rem;
  border: ${ props => props.error ? '1px solid rgba(255,98,86,1)' : '1px solid #e1e3f4'};
  background: ${props => props.disabled ? 'rgba(229, 232, 241, 1)' : 'inherit'};
  
  &:focus {
    outline: none;
    border: 1px solid rgba(89, 89, 89, 1);
    color: rgba(39, 39, 39, 1);
  }

  ${props => props.thisStyles}
`;
